<template>
  <div>
    <div class="back-wrap" @click="toHome" v-if="!isMobileDevice()">返回</div>
    <div class="centerWidth detail-wrap">
      <table border="1" class="dagang">
        <tr>
          <td :colspan="3">
            <div class="title-wrap">
              <img class="img1" src="../assets/images/logo1.png" alt="">
              <img class="img2" src="../assets/images/dagang_title.png" alt="">
              <img class="img3" src="../assets/images/dagang_title2.jpg" alt="">
            </div>
          </td>
        </tr>
        <tr>
          <div class="title-major">{{dataInfo.major_name}}</div>
          <div class="title-score"> ( 满分{{dataInfo.score}}分，考试时间{{dataInfo.time}}分钟 )</div>
          <div>
            <div v-for='(item, index) in allList' :key='index' class='list-ti'>
              <div v-if='item.question_type == 1' class="biaoti">
                <span class='tit1'>一. 单选题</span>
                <span class='tit2'>(每道题只有一个正确答案，共 {{
                    item.questions.length || 0
                  }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
              </div>
              <div v-if='item.question_type == 2' class="biaoti">
                <span class='tit1'>二. 多选题</span>
                <span class='tit2'>(每道题答案数目不固定，共 {{
                    item.questions.length || 0
                  }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
              </div>
              <div v-if='item.question_type == 3' class="biaoti">
                <span class='tit1'>三. 判断题</span>
                <span class='tit2'>(选择正确或错误，共 {{
                    item.questions.length || 0
                  }}题，合计{{ (item.questions.length || 0) * item.score }}分)</span>
              </div>
              <div class='mt10 ml30'>
                <div v-for='(item1, index1) in item.questions' class='mt10 mb10' :key="index1">
                  <div class="timu_tit">
                    <span>{{ index1 + 1 }}. </span>
                    <span>{{ item1.title }}</span>
                  </div>
                  <div v-if='item1.type == 1'>
                    <div class='ml50 d-flex d-wrap'>
                      <div v-for="(item2, index2) in item1.option" class='ml20 mt10 mr20' :key="index2">
                         <span
                             :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                             item2.label
                           }}. {{ item2.content }}</span>
                      </div>
                    </div>
                    <div class="d-flex d-align-center daan-wrap">
                      <div class="tit11">[ 正确答案：{{item1.answer}} ]</div>
                      <div class="tit22">[ 考生答案：{{item1.student_answerinfo.student_answer}} ]</div>
                      <div class="img1" v-if="item1.answer == item1.student_answerinfo.student_answer">
                        <img src="../assets/images/dui.png" alt="">
                        <div>+{{Number(item1.student_answerinfo.score).toFixed(0)}}分</div>
                      </div>
                      <div class="img2" v-else>
                        <img src="../assets/images/cuo.png" alt="">
                      </div>
                    </div>
                    <div class="tit33">
                      [ 答案解析：{{item1.jiexi?item1.jiexi:'无'}} ]
                    </div>
                  </div>
                  <div v-if='item1.type == 2'>
                    <div class='ml50 d-flex d-wrap'>
                      <div v-for="(item2, index2) in item1.option" class='ml20 mt10 mr20' :key="index2">
                      <span
                          :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                          item2.label
                        }}. {{ item2.content }}</span>
                      </div>
                    </div>
                    <div class="d-flex d-align-center daan-wrap d-wrap">
                      <div class="tit11">[ 正确答案：{{item1.answer}} ]</div>
                      <div class="tit22">[ 考生答案：{{item1.student_answerinfo.student_answer}} ]</div>
                      <div class="img1" v-if="item1.answer == item1.student_answerinfo.student_answer">
                        <img src="../assets/images/dui.png" alt="">
                        <div>+{{Number(item1.student_answerinfo.score).toFixed(0)}}分</div>
                      </div>
                      <div class="img2" v-else>
                        <img src="../assets/images/cuo.png" alt="">
                      </div>
                    </div>
                    <div class="tit33">
                      [ 答案解析：{{item1.jiexi?item1.jiexi:'无'}} ]
                    </div>
                  </div>
                  <div v-if='item1.type == 3'>
                    <div class='ml50 d-flex d-wrap' >
                      <div v-for="(item2, index2) in item1.option" class='ml20 mt10 mr20' :key="index2">
                         <span
                             :style="{ color: item2.hoverColor || item2.defaultColor,backgroundColor:'#fff',fontSize:'16px' }">{{
                             item2.label
                           }}. {{ item2.content }}</span>
                      </div>
                    </div>
                    <div class="d-flex d-align-center daan-wrap d-wrap">
                      <div class="tit11">[ 正确答案：{{item1.answer}} ]</div>
                      <div class="tit22">[ 考生答案：{{item1.student_answerinfo.student_answer}} ]</div>
                      <div class="img1" v-if="item1.answer == item1.student_answerinfo.student_answer">
                        <img src="../assets/images/dui.png" alt="">
                        <div>+{{Number(item1.student_answerinfo.score).toFixed(0)}}分</div>
                      </div>
                      <div class="img2" v-else>
                        <img src="../assets/images/cuo.png" alt="">
                      </div>
                    </div>
                    <div class="tit33">
                      [ 答案解析：{{item1.jiexi?item1.jiexi:'无'}} ]
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  getRecord,
  item_lists,
  item_detail
} from "@/api/index";
import {find_chengji} from "../api";

export default {
  name: "courseList",
  data() {
    return {
      student_id: '',
      major_id: '',
      shijuan_id: '',
      allList: [],
      dataInfo:{},
      isMobile: false,
    }
  },
  mounted() {
    this.xuehao = this.$route.query.xuehao
    this.getInfo()
    // if (this.$route.query.student_id) {
    //   this.student_id = this.$route.query.student_id
    //   this.shijuan_id = this.$route.query.shijuan_id
    //   this.major_id = this.$route.query.major_id
    //   this.getDetails()
    // }else{
    //   let info = JSON.parse(this.$route.query.info)
    //   this.student_id = info.student_id
    //   this.shijuan_id = info.shijuan_id
    //   this.major_id = info.major_id
    //   this.getDetails()
    // }
  },
  methods: {
    getInfo() {
      let ajaxData = {
        xuehao: this.xuehao
      }
      find_chengji(ajaxData).then(res => {
        if (res.code == 1) {
          let dataInfo = res.data[0]
          this.student_id = dataInfo.student_id
          this.shijuan_id = dataInfo.shijuan_id
          this.major_id = dataInfo.major_id
          this.getDetails()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    isMobileDevice() {
      // 使用 window.innerWidth 获取视口宽度
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      // 这里我们假设宽度小于等于768px的为移动设备
      // 你可以根据实际需要调整这个阈值
      return width <= 768;
    },
    getDetails() {
      getRecord({student_id: this.student_id, major_id: this.major_id, shijuan_id: this.shijuan_id}).then(res => {
        if (res.code == 1) {
          let data = res.data.list
          for (let i in data) {
            for (let j in data[i].questions) {
              if (data[i].questions[j].type == 3) {
                data[i].questions[j].option = [
                  {
                    label: '1',
                    defaultColor: "#333",
                    hoverColor: null,
                    content: '正确',
                  },
                  {
                    label: '2',
                    defaultColor: "#333",
                    hoverColor: null,
                    content: '错误',
                  }
                ]
              } else {
                if (typeof data[i].questions[j].option == 'string') {
                  let option = data[i].questions[j].option.split('\n')
                  const options = option.map((item, index) => {
                    return {
                      label: String.fromCharCode(65 + index),
                      defaultColor: "#333",
                      hoverColor: null,
                      content: item,
                    };
                  });
                  data[i].questions[j].option = options
                }
              }
            }
          }
          this.allList = data
          this.dataInfo = res.data.info
        }
      })
    },
    toHome() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
.back-wrap {
  cursor: pointer;
  position: absolute;
  right: 50px;
  top: 30px;
  padding: 10px 30px;
  border-radius: 20px;
  border: 1px solid #2257ab;
  color: #2257ab;
}
.detail-wrap {
  width: 900px;
  margin-top: 50px;
  margin-bottom: 50px;
  overflow: hidden;
  //border: 1px solid #ddd; /* 容器边框 */
  //border-radius: 10px; /* 圆角半径 */
  //overflow: hidden; /* 隐藏超出圆角的部分 */

  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 100px;
    width: 700px;
    line-height: 100px;
    margin: 0 auto;
    color: #ffffff;
    letter-spacing: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dagang {
    width: 100%;
    margin: 0 auto;
    border-radius: 15px;

    tr {
      height: 56px;

      th {
        color: #333;
        font-weight: bold;
        font-size: 18px;
      }

      td:nth-child(1) {
        padding-left: 20px;
      }

      td:nth-child(2) {
        text-align: center;
        font-size: 20px;
      }
    }
  }
}

.title-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;

  .img1 {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .img2 {
    width: 600px;
    height: 45px;
    padding-top: 30px;
  }

  .img3 {
    width: 350px;
    height: 40px;
    margin-top: 30px;
  }
}

.list-ti {
  width: 858px;
  padding: 30px 20px 0 20px;

  &:last-child {
    margin-bottom: 30px;
  }

  .biaoti {
    border-radius: 5px;
    display: flex;
    align-items: center;
  }

  .tit1 {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }

  .tit2 {
    font-size: 14px;
    color: #999;
    margin-left: 20px;
  }
}
.mt10 {
  margin-top: 15px;
  font-size: 16px;
}
.mr20{
  margin-right: 20px;
}
.ml30{
  margin-left: 30px;
}
.tit33{
  color: #007bff !important;
}
.daan-wrap{
  .tit11{
    color: #28a745 !important;
    margin-right: 20px;
  }
  .tit22{
    color: #dc3545 !important;
  }
  .img1{
    display: flex;
    align-items: center;
    margin-left: 20px;
    div{
      color: #333;
    }
  }
  .img2{
    width: 30px;
    height: 30px;
    img{
      width: 30px;
      height: 30px;
    }
    margin-left: 10px;
  }
}
.title-major{
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}
.title-score{
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
  color: #6666;
}
@media only screen and (max-width: 600px) {
  #app{
    width: 100%;
  }
  .detail-wrap{
    width: calc(100%);
    padding: 0 10px;
    box-sizing: border-box;
  }
  .title-wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 10px 20px 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .img1 {
      position: absolute;
      top: 15px;
      left: 0px;
      width: 30px;
      height: 30px;
    }

    .img2 {
      width: 260px;
      height: 22px;
      padding-top: 30px;
    }

    .img3 {
      width: 160px;
      height: 18px;
      margin-top: 20px;
    }
  }
  .detail-wrap .dagang tr td:nth-child(1){
    padding-left: 10px;
  }
  .list-ti {
    width: 320px;
    padding: 30px 20px 0 20px;

    &:last-child {
      margin-bottom: 30px;
    }

    .biaoti {
      border-radius: 5px;
      display: block;
      align-items: center;
    }

    .tit1 {
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }

    .tit2 {
      font-size: 14px;
      color: #999;
      margin-left: 20px;
    }
  }
  .mt10 {
    margin-top: 15px;
    font-size: 16px;
  }
  .mr20{
    margin-right: 20px;
  }
  .ml30{
    margin-left: 0px;
  }
  .daan-wrap{
    display: flex;
    margin-top: 10px;
    img{
      width: 20px;
      height: 20px;
    }
    .img1{
      margin-left: 10px;
    }
    .tit11{
      margin-right: 10px;
    }
  }
  .tit33{
    margin-top: 10px;
  }
}
</style>
